export default __webpack_public_path__ + "static/media/1304.5e4dedbf.jpg";